import HttpClient from "../../../service/HttpService";
import state from "./state";


export default {
    getUser({commit}) {
        return new Promise((resolve, reject) => {
            if (state.user) {
                resolve(state.user);
            } else {
                HttpClient.backApi.get("/auth/clarify").then(response => {
                    state.user = response.data;
                    resolve(state.user);
                });
            }
        });
    }
};